export const Container = require('../../src/front/News/Container').default;
export const Index = require('../../src/front/News/NewsIndex').default;
export const Show = require('../../src/front/News/Show').default;
